<div class='modal-dialog' role='document'>
  <div class='modal-content'>
    <div class='modal-header'>
      <h3 class='modal-title' id='exampleModalLabel'>Drop a pin anywhere</h3>
      <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>
    <div class='modal-body'>
      <button class='btn btn-primary' (click)='getLocation()'>Use current location</button>
      <google-map
        height='100%'
        width='auto'
        class='pr-2'
        [zoom]='15'
        [center]='center'
        (mapMousemove)="move($event)"
      (mapClick)='mapClick($event)'>
        <map-marker
          #markerElem='mapMarker'
          id='pin'
          (click)='markerClick()'
          [position]='display'
          [options]='markerOptions'>
        </map-marker>
      </google-map>
    </div>
    <div class='modal-footer mt-3'>
      <button type='button' class='btn btn-secondary' data-dismiss='modal'>Close</button>
      <button type='button' class='btn btn-primary' data-dismiss='modal' (click)='saveLocation()'>Save location</button>
    </div>
  </div>
</div>
